export function eraseCookie(cookieName: string, domainUrl: string) {
  document.cookie = `${cookieName}=; path=/; domain=${domainUrl}`;
}
